/**
 * ============================================================================
 * RK PRODUCT VIDEO JAVASCRIPT
 * YouTube Video Einbettung via Metafeld
 * ============================================================================
 *
 * Powered by René Kress - Crovio
 * www.crovio.de
 *
 * © 2025 All Rights Reserved
 * ============================================================================
 */

(function () {
  'use strict';

  const section = document.querySelector('.rk-product-video');
  if (!section) return;

  const rawUrl = section.dataset.youtubeUrl || '';
  if (!rawUrl) return;

  const wrapper = document.getElementById('rk-pv-embed-wrapper');
  const placeholder = document.getElementById('rk-pv-placeholder');
  if (!wrapper || !placeholder) return;

  // ==========================================
  // URL PARSEN → Video-ID + Typ ermitteln
  // ==========================================

  function parseYouTubeUrl(url) {
    let videoId = null;
    let isShorts = false;

    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname.replace('www.', '');

      // Shorts: youtube.com/shorts/VIDEO_ID
      const shortsMatch = parsed.pathname.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
      if (shortsMatch) {
        videoId = shortsMatch[1];
        isShorts = true;
      }

      // youtu.be/VIDEO_ID
      if (!videoId && hostname === 'youtu.be') {
        videoId = parsed.pathname.replace('/', '').split('?')[0];
      }

      // youtube.com/watch?v=VIDEO_ID
      if (!videoId && parsed.searchParams.has('v')) {
        videoId = parsed.searchParams.get('v');
      }

      // youtube.com/embed/VIDEO_ID
      if (!videoId) {
        const embedMatch = parsed.pathname.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
        if (embedMatch) videoId = embedMatch[1];
      }

    } catch (e) {
      console.error('RK Product Video - Ungültige URL:', url, e);
    }

    return { videoId, isShorts };
  }

  // ==========================================
  // EMBED BAUEN
  // ==========================================

  function buildEmbed(videoId, isShorts) {
    // Aspect-Ratio-Klasse setzen
    wrapper.classList.add(isShorts ? 'is-shorts' : 'is-standard');

    // Placeholder aspect-ratio anpassen
    placeholder.style.aspectRatio = isShorts ? '9 / 16' : '16 / 9';

    // ── Thumbnail als Hintergrundbild ──────────────────────────────────────
    // YouTube stellt für jeden Video-ID automatisch Thumbnails bereit.
    // Für Shorts: hqdefault ist zuverlässiger als maxresdefault.
    const thumbQuality = isShorts ? 'hqdefault' : 'maxresdefault';
    const thumbUrl = `https://i.ytimg.com/vi/${videoId}/${thumbQuality}.jpg`;
    placeholder.style.backgroundImage = `url('${thumbUrl}')`;
    placeholder.style.backgroundSize = 'cover';
    placeholder.style.backgroundPosition = 'center';

    // Klick auf Placeholder → iframe einbetten
    placeholder.addEventListener('click', function loadIframe() {
      placeholder.removeEventListener('click', loadIframe);
      placeholder.style.display = 'none';

      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId
        + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      iframe.title = 'Produkt Video';

      wrapper.appendChild(iframe);

      console.log('RK Product Video - Iframe geladen:', iframe.src);
    }, { once: true });
  }

  // ==========================================
  // INIT
  // ==========================================

  function init() {
    const { videoId, isShorts } = parseYouTubeUrl(rawUrl);

    if (!videoId) {
      console.warn('RK Product Video - Keine Video-ID gefunden in URL:', rawUrl);
      section.style.display = 'none';
      return;
    }

    console.log('RK Product Video - Video-ID:', videoId, '| Shorts:', isShorts);
    buildEmbed(videoId, isShorts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();